if (!customElements.get('customer-reviews-scroller')) {
  class CustomerReviewsScroller extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.track = this.querySelector('[data-reviews-track]');
      this.dragMultiplier = 1.35;
      this.rafId = null;
      this.pendingScrollLeft = null;
      this.suppressClick = false;

      if (!this.track || this.dataset.dragEnabled !== 'true') return;
      if (window.matchMedia('(pointer: coarse)').matches) return;

      this.dragState = null;
      this.handlePointerDown = this.onPointerDown.bind(this);
      this.handlePointerMove = this.onPointerMove.bind(this);
      this.handlePointerUp = this.onPointerUp.bind(this);
      this.handleDragStart = this.onDragStart.bind(this);
      this.handleClickCapture = this.onClickCapture.bind(this);

      this.track.addEventListener('pointerdown', this.handlePointerDown);
      this.track.addEventListener('pointermove', this.handlePointerMove);
      this.track.addEventListener('pointerup', this.handlePointerUp);
      this.track.addEventListener('pointercancel', this.handlePointerUp);
      this.track.addEventListener('lostpointercapture', this.handlePointerUp);
      this.track.addEventListener('dragstart', this.handleDragStart);
      this.track.addEventListener('click', this.handleClickCapture, true);
    }

    disconnectedCallback() {
      if (!this.track || !this.handlePointerDown) return;

      this.track.removeEventListener('pointerdown', this.handlePointerDown);
      this.track.removeEventListener('pointermove', this.handlePointerMove);
      this.track.removeEventListener('pointerup', this.handlePointerUp);
      this.track.removeEventListener('pointercancel', this.handlePointerUp);
      this.track.removeEventListener('lostpointercapture', this.handlePointerUp);
      this.track.removeEventListener('dragstart', this.handleDragStart);
      this.track.removeEventListener('click', this.handleClickCapture, true);

      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
      }
    }

    onPointerDown(event) {
      if (event.pointerType === 'touch' || event.button !== 0) return;
      if (event.target.closest('a, button, input, textarea, select, label')) return;

      this.dragState = {
        pointerId: event.pointerId,
        startX: event.clientX,
        startScrollLeft: this.track.scrollLeft,
        moved: false
      };
      this.suppressClick = false;

      this.track.classList.add('is-dragging');
      this.track.style.scrollSnapType = 'none';
      this.track.style.scrollBehavior = 'auto';

      if (this.track.setPointerCapture) {
        this.track.setPointerCapture(event.pointerId);
      }

      event.preventDefault();
    }

    onPointerMove(event) {
      if (!this.dragState || event.pointerId !== this.dragState.pointerId) return;

      const deltaX = (event.clientX - this.dragState.startX) * this.dragMultiplier;

      if (Math.abs(deltaX) > 4) {
        this.dragState.moved = true;
      }

      this.pendingScrollLeft = this.dragState.startScrollLeft - deltaX;

      if (!this.rafId) {
        this.rafId = requestAnimationFrame(() => {
          this.track.scrollLeft = this.pendingScrollLeft;
          this.rafId = null;
        });
      }

      event.preventDefault();
    }

    onPointerUp(event) {
      if (!this.dragState) return;
      if (event.pointerId != null && event.pointerId !== this.dragState.pointerId) return;

      if (this.track.hasPointerCapture && this.track.hasPointerCapture(this.dragState.pointerId)) {
        this.track.releasePointerCapture(this.dragState.pointerId);
      }

      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }

      this.suppressClick = this.dragState.moved;
      this.dragState = null;
      this.track.classList.remove('is-dragging');
      this.pendingScrollLeft = null;

      requestAnimationFrame(() => {
        this.track.style.scrollBehavior = '';
        this.track.style.scrollSnapType = '';
      });
    }

    onDragStart(event) {
      event.preventDefault();
    }

    onClickCapture(event) {
      if (!this.suppressClick) return;

      event.preventDefault();
      event.stopPropagation();
      this.suppressClick = false;
    }
  }

  customElements.define('customer-reviews-scroller', CustomerReviewsScroller);
}
